/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown>, to: NonNullable<unknown>, total: NonNullable<unknown> }} Ticketpagerange2Inputs */

const en_ticketpagerange2 = /** @type {(inputs: Ticketpagerange2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}-${i?.to} of ${i?.total}`)
};

const de_ticketpagerange2 = /** @type {(inputs: Ticketpagerange2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.from}-${i?.to} von ${i?.total}`)
};

/**
* | output |
* | --- |
* | "{from}-{to} of {total}" |
*
* @param {Ticketpagerange2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpagerange2 = /** @type {((inputs: Ticketpagerange2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpagerange2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpagerange2(inputs)
	return de_ticketpagerange2(inputs)
});
export { ticketpagerange2 as "ticketPageRange" }